import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import mclovin from '../Imatges/mclovin.jpg'
import logo from '../Imatges/logoUsuari.jpg'
import CachaunCompressed from '../Video/Cachaun-compressed2.mp4'
import './Alquilar.css'
import SearchBar from '../Components/searchBar'
import { useTheme } from '../ThemeContext'
import { AnimatedThemeToggler } from '../Components/themeToggler'
import { getVehiclesByType } from '../services/vehicleService'
import { searchVehicles } from '../services/searchService'
import VehicleCard from '../Components/VehicleCard'
import { useAuth } from '../contexts/AuthContext'
import Navigation from '../Components/Navigation'

function Alquilar() {
  const [showMenu, setShowMenu] = useState(false)
  const [searchResults, setSearchResults] = useState(null)
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { isDarkMode, toggleTheme } = useTheme()
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showMenu && !event.target.closest('.contenidorPerfil')) {
        setShowMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showMenu])

  // Carregar vehicles de lloguer quan es munta el component
  useEffect(() => {
    const loadRentalVehicles = async () => {
      try {
        setLoading(true)
        const rentalVehicles = await getVehiclesByType('Alquilar')
        setVehicles(rentalVehicles)
      } catch (err) {
        setError('Error al cargar los vehículos de alquiler')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    loadRentalVehicles()
  }, [])

  // Función para manejar la búsqueda (solo en vehículos de alquiler)
  const handleSearch = async searchTerm => {
    try {
      setLoading(true)
      // Buscar solo en vehículos de tipo "Alquilar"
      const results = await searchVehicles(searchTerm, 'Alquilar')
      setSearchResults(results)
      setLoading(false)
    } catch (err) {
      console.error('Error en búsqueda:', err)
      setError('Error al buscar vehículos')
      setLoading(false)
    }
  }

  // Función para limpiar la búsqueda
  const handleClearSearch = () => {
    setSearchResults(null)
  }

  // Determinar qué vehículos mostrar
  const vehiclesToDisplay = searchResults !== null ? searchResults : vehicles

  return (
    <div className='App'>
      <img src={mclovin} className='mclovin-logo' alt='imatge_mclovin' />
      {/* Icona del perfil a dalt a la dreta */}
      <div className='contenidorPerfil'>
        <div className='desplegablePerfil'>
          <img src={logo} className='logo-usuari' alt='usuari_logo' onClick={() => setShowMenu(!showMenu)} style={{ cursor: 'pointer' }} />
          {showMenu && (
            <div className='menuPerfil'>
              <p>Perfil</p>
              <p>Configuración</p>
              <p>Idioma</p>
              {user && (
                <p
                  onClick={() => {
                    navigate('/mis-vehiculos')
                    setShowMenu(false)
                  }}
                  style={{ cursor: 'pointer', color: '#61dafb', fontWeight: 'bold' }}
                >
                  Mis Vehículos
                </p>
              )}
              <p
                onClick={async () => {
                  console.log('CLICK en Cerrar sesion')
                  setShowMenu(false)
                  const result = await signOut()
                  console.log('Resultado de signOut:', result)
                  console.log('Redirigiendo a /login...')
                  window.location.href = '/login'
                }}
                style={{ cursor: 'pointer', color: '#61dafb', fontWeight: 'bold' }}
              >
                Cerrar sesión
              </p>
              <p>Ajuda</p>
              <div style={{ display: 'block', alignItems: 'center', gap: '10px', padding: '10px 0' }}>
                <AnimatedThemeToggler />
              </div>
            </div>
          )}
        </div>
      </div>
      <header className='appCabecera'>
        <h1 className='titulPrincipal' onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          MotorVault
        </h1>
        {/* Barra de menús con componente Navigation */}
        <Navigation />
        <SearchBar onSearch={handleSearch} onClear={handleClearSearch} placeholder='Buscar vehículos en alquiler...' />
      </header>

      {/* Secció nova per al vídeo */}
      <div className='video-section'>
        <video className='video-player' autoPlay loop muted playsInline>
          <source src={CachaunCompressed} type='video/mp4' />
          El teu navegador no suporta l'element de vídeo.
        </video>
      </div>

      {/* Secció de vehicles de lloguer */}
      <div className='vehicles-section'>
        <h2 className='section-title' style={{ color: '#61dafb' }}>
          {searchResults !== null ? `Resultados en Alquiler (${searchResults.length})` : 'Vehículos en Alquiler'}
        </h2>
        {loading ? (
          <p style={{ textAlign: 'center', color: 'var(--text-color)' }}>Cargando vehículos...</p>
        ) : error ? (
          <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>
        ) : searchResults !== null && searchResults.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
            <p style={{ fontSize: '20px' }}>😕 No se encontraron vehículos de alquiler</p>
            <p>Intenta con otros términos de búsqueda</p>
          </div>
        ) : vehiclesToDisplay.length === 0 ? (
          <p style={{ textAlign: 'center', color: 'var(--text-color)' }}>No hay vehículos disponibles para alquilar</p>
        ) : (
          <div className='carousel' mask='true'>
            {vehiclesToDisplay.map(vehicle => (
              <VehicleCard key={vehicle['vehicle_id(PK)']} vehicle={vehicle} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Alquilar
